import { createRouter, createWebHistory } from 'vue-router'
import { constantRoutes, asyncRoutes } from './routes'
import { setupRouterGuards } from './guards'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  }
})

// // 动态添加路由
// export function addAsyncRoutes() {
//   asyncRoutes.forEach(route => {
//     if (!router.hasRoute(route.name)) {
//       router.addRoute(route)
//     }
//   })
// }

// 设置路由守卫
setupRouterGuards(router)

export default router